import React from 'react';
import { useState/*, useEffect*/ } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/landingPage';
import House1Page from './pages/housePage1';
import House2Page from './pages/housePage2';
import ContactsPage from './pages/contactsPage';
import RatesPage from './pages/ratesPage';
import DintorniPage from './pages/dintorniPage';

const App = () => {

  const [selectedLanguage, setSelectedLanguage] = useState('ita');

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage selectedLanguage={selectedLanguage} handleLanguageChange={handleLanguageChange} />} />
        <Route path="/house1" element={<House1Page selectedLanguage={selectedLanguage} handleLanguageChange={handleLanguageChange} />} />
        <Route path="/house2" element={<House2Page selectedLanguage={selectedLanguage} handleLanguageChange={handleLanguageChange} />} />
        <Route path="/contacts" element={<ContactsPage selectedLanguage={selectedLanguage} handleLanguageChange={handleLanguageChange} />} />
        <Route path="/rates" element={<RatesPage selectedLanguage={selectedLanguage} handleLanguageChange={handleLanguageChange} />} />
        <Route path="/surroundings" element={<DintorniPage selectedLanguage={selectedLanguage} handleLanguageChange={handleLanguageChange} />} />
      </Routes>
    </Router>

  );
}

export default App;

